// Shared query-param builder for createStateV2* mutations. Keeps the
// "direct copy" bypass params (used by UserStates/CopyState) consistent
// across every per-game state API file.
export const buildStateCreateParams = ({vendorId, isDirectCopy, sourceUserId, sourceVendorId, comment, zendeskTicketId}) => {
    const params = new URLSearchParams({vendorId})

    if (isDirectCopy) {
        params.set("isDirectCopy", "true")
        if (sourceUserId) params.set("sourceUserId", sourceUserId)
        if (sourceVendorId) params.set("sourceVendorId", sourceVendorId)
        if (comment) params.set("comment", comment)
        if (zendeskTicketId) params.set("zendeskTicketId", zendeskTicketId)
    }

    return params
}
